import { render, staticRenderFns } from "./DeletedUsersOverview.vue?vue&type=template&id=571c712f&scoped=true&"
import script from "./DeletedUsersOverview.vue?vue&type=script&lang=js&"
export * from "./DeletedUsersOverview.vue?vue&type=script&lang=js&"
import style0 from "./DeletedUsersOverview.vue?vue&type=style&index=0&id=571c712f&prod&lang=css&scoped=true&"
import style1 from "./DeletedUsersOverview.vue?vue&type=style&index=1&id=571c712f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571c712f",
  null
  
)

export default component.exports